/**
 * Internal dependencies
 */
import BlockMenuItem from './block-menu-item';

/**
 * 
 */
class BlockMenu {

	/**
	 * 
	 * @type HTMLElement
	 */
	element = null;

	/**
	 * 
	 * @type String
	 */
	menuItemClassName = 'menu-item';

	/**
	 * 
	 * @type BlockMenuItem[]
	 */
	menuItemList = [];

	/**
	 * 
	 * @type String
	 */
	menuItemSelector = ':scope > .block-list > .menu-item';

	/**
	 * 
	 * @type HTMLElement[]
	 */
	// menuItemLinkList = [];

	/**
	 * 
	 * @type String
	 */
	menuItemLinkSelector = '.menu-item-link';

	/**
	 * 
	 * @param {HTMLElement} element 
	 */
	constructor( element )
	{
		this.element = element;
		this.element.wmuBlockMenu = this;
	}

	/**
	 * 
	 */
	clear()
	{
		this.menuItemList.forEach( ( blockMenuItem ) =>
		{
			blockMenuItem.clear();
		} );

		this.menuItemList = [];
		this.element.wmuBlockMenu = undefined;

	}

	/**
	 * 
	 */
	setup()
	{
		/**
		 * Add current class to items
		 */
		const currentBaseURL = window.location.href.split( '#' )[0];

		this.element.querySelectorAll( this.menuItemLinkSelector ).forEach( ( linkElement ) =>
		{
			if ( currentBaseURL === linkElement.href )
			{
				const menuItemElement = linkElement.closest( `.${this.menuItemClassName}` );
				linkElement.classList.add( 'current' );

				if ( menuItemElement )
				{
					menuItemElement.classList.add( 'current' );
				}
			}
		} );

		/**
		 * 
		 */
		this.element.querySelectorAll( this.menuItemSelector ).forEach( ( menuItemElement ) =>
		{
			if ( ! menuItemElement.wmuBlockMenuItem )
			{
				this.menuItemList.push( new BlockMenuItem( menuItemElement ) );
			}
		} );
	}

}

export default BlockMenu;